<template>
  <div class="input-wrapper">
    <label :for="id" v-if="label" :class="{active: value && value.length > 0}">{{label}}</label>
    <textarea :name="name" :id="id" v-model="value"
              :placeholder="placeholder"
              ref="textareaValue"
              :class="classList" :maxlength="maxLength" :rows="rows"
              resize="vertical"></textarea>
  </div>
</template>

<script>
  export default {
    props: {
      name: String,
      defaultValue: String,
      label: String,
      placeholder: String,
      light: { type: Boolean, default: false, },
      id: String,
      maxLength: { default: 255, },
      rows: { default: 10, },
      noTextNormal: { type: Boolean, default: false, },
    },
    data() {
      return {
        value: '',
      };
    },
    computed: {
      classList() {
        return [{ 'theme-light': this.light, 'theme-normal': !this.light && !this.noTextNormal }];
      },
    },
    mounted() {
      this.value = this.defaultValue;
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/typography.scss";

  .input-wrapper {
    position: relative;
    display: block;
    // overflow: hidden;
    margin: 0 5px 5px 0;
    textarea {
      @include font-size($font-size-p);
      color: $color-input-text;
      padding: 25px 15px;
      border: none;
      display: block;
      width: 100%;
      box-sizing: border-box;
      outline: none !important;
      &.theme-light {
        background: $color-white;
      }
      &.theme-normal {
        background: $color-blue-6;
        @include ease(background);
        &:focus {
          outline: 2px solid $color-text !important;
          background: $color-white;
        }
      }

      @include placeholder {
        line-height: 50px;
        color: $color-input-placeholder;
        font-size: $font-size-p !important;
        text-transform: uppercase;
        transition: color 0.2s ease-in-out;
      }

      &:focus {
        @include placeholder {
          color: $color-input-text !important;
        }
      }
    }
  }

</style>


// WEBPACK FOOTER //
// components/shared/_any/InputTextarea.vue